import React from 'react';
import '../Css/About.css'
import logo from '../images/mohammad.jpg'
import resume from '../images/myResume.pdf'

const About = () => {
  return (
    <>
      <div className='about-container lg:mt-40 mb-28 lg:mb-0 ' id='about'>
        <div className=''>
          <h1 className=' bg-slate-700 inline mx-auto font-bold text-white  lg:text-2xl p-2 rounded-lg text-center 
           absolute mt-18  lg:mt-52 about-title'>ABOUT ME</h1>
        </div>
        <div class="hero pt-12 lg:pt-0 lg:min-h-screen mb-10 ">

          <div class="hero-content flex-col lg:flex-row-reverse lg:gap-x-32 mt-6 lg:mt-12">
            <img src={logo} />
            <div className='text-base lg:text-xl  about-section  lg:mt-4'>
              <p class="">Hello! I'm Mohammad Borhan Uddin, a passionate web developer. I develop web applications. My core skill is based on JavaScript, React and I love to do most of the things using JavaScript, React. I love to make the web more open to the world. You can experiment with me to give any task with new technology. I will always learn and try to adjust to the environment. I am available for any kind of job opportunity that suits my interests.</p>
              <div className='mt-9 lg:mt-14 px-7 lg:px-0 text-white'>
                <a className='homepage-button  bg-yellow-500 hover:bg-slate-800 text-yellow-500' href={resume} download='myResume'>Get Resume </a>
                <a className='homepage-button ml-5 lg:ml-7' href="#skills">My Skills</a>
              </div>
            </div>
          </div>
        </div>
      </div>

    </>
  );
};

export default About;